"use strict";

var FoG = window.FoG = window.FoG || {};

if (!FoG || !FoG.exists) {
  (function ($) {
    FoG.exists = true;
    
    function prepClipboard($src) {
      var clipboard = new ClipboardJS('.fa-copy');

      clipboard.on('success', (e) => {
        var target = $(e.trigger).attr('data-clipboard-target');
        var $target = $(target);
        var $ascending = $target.clone().appendTo($target.parent());
        FoG.Effects.ascend($ascending);
      });
    }
    
    function init() {
      $(() => window.Nacl.LitePopup.apply('.article__thumbContainer, .article__socialOverlay, .signal__widgets, .comment'));
      prepClipboard($('.fa-copy'));
    }
    
    FoG.urlParam = function (name, queryString) {
      queryString = queryString || window.location.search; 
      
      var results = new RegExp('[\?&]' + name + '=([^&#]*)')
        .exec(queryString);

      return (results !== null) ? results[1] || 0 : false;
    }
    
    $(init);
  
    FoG.prepClipboard = prepClipboard;
  })(jQuery)
}

